import { html, TemplateResult } from 'lit';
import { advanceStep, STEP_AVAILABILITY } from '../../../types/steps';
import { BookingRequest, Dispatcher } from '../../../types/booking-request';
import { checkIfBookingDataIsValid } from '../../../types/booking-data';
import { staticText } from '../../../static-text';

export function seeSummaryButton(
	state: BookingRequest,
	dispatch: Dispatcher
): TemplateResult {
	const incrementCurrentStepHandler = () => {
		if ( STEP_AVAILABILITY !== state.currentStep ) {
			return;
		}

		dispatch( {
			type: 'UPDATE_CURRENT_STEP',
			currentStep: advanceStep( state.currentStep ),
		} );
	};

	return html`
		<button
			.disabled=${!checkIfBookingDataIsValid( state.bookingData.weekData )}
			@click=${incrementCurrentStepHandler}
			class="button"
		>
			${staticText.seeSummary}
		</button>
	`;
}
